import { Component, Injector, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';

import { ModalBasePage } from '../base/modal-base.page';

@Component({
  selector: 'app-modal-location-permission',
  templateUrl: 'modal-location-permission.page.html',
  styleUrls: ['modal-location-permission.page.scss'],
})
export class ModalLocationPermissionPage extends ModalBasePage implements OnInit {
  titleKey: string;
  descriptionKey: string;
  confirmKey: string;
  // Quando a permissão já está bloqueada não há o que "permitir" a partir do app,
  // então o modal vira apenas informativo (sem a opção de recusar).
  hideCancel: boolean;

  constructor(
    private navParams: NavParams,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.titleKey = this.navParams.get('titleKey') || 'MODAL.LOCATION_USE';
    this.descriptionKey =
      this.navParams.get('descriptionKey') || 'MODAL.USE_LOCATION_TO_FIND_NEARBY_STORES';
    this.confirmKey = this.navParams.get('confirmKey') || 'MODAL.ALLOW';
    this.hideCancel = !!this.navParams.get('hideCancel');
  }

  ok(): void {
    this.modalCtrl.dismiss(true);
  }
}
